// extracted by mini-css-extract-plugin
module.exports = {"container":"ArrowX_container__V67kz","arrow":"ArrowX_arrow__TG_yA"};